import React from 'react'
import NotFoundComponent from '../components/NotFound'

export default function NotFound() {
  return (
    <NotFoundComponent/>
  )
}
